import React from 'react';
import PageHeader, { Highlight } from '../components/ui/PageHeader';
import Button from '../components/ui/Button';

const ASSET_TYPES = [
  { icon: '⬡', label: 'App Icon',      sizes: ['48x48', '72x72', '96x96', '144x144', '192x192'], status: 'missing' },
  { icon: '◈', label: 'Splash Screen', sizes: ['480x800', '720x1280', '1080x1920'],               status: 'ok' },
  { icon: '⊞', label: 'Notification',  sizes: ['24x24', '36x36', '48x48'],                        status: 'warn' },
  { icon: '◉', label: 'Adaptive Icon', sizes: ['108x108'],                                         status: 'missing' },
];

const statusColor: Record<string, string> = {
  ok: 'var(--success)',
  warn: 'var(--warning)',
  missing: 'var(--error)',
};

const AssetsPage: React.FC = () => (
  <>
    <PageHeader
      title={<>Asset <Highlight>Manager</Highlight></>}
      subtitle="Manage icons, splash screens, and resources for all screen densities"
    />

    <div style={{ display: 'flex', gap: 10, marginBottom: 24 }}>
      <Button variant="primary" icon="⬆">Upload Asset</Button>
      <Button variant="secondary" icon="⊞">Auto Generate</Button>
    </div>

    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 16 }}>
      {ASSET_TYPES.map((asset) => (
        <div key={asset.label} style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 'var(--radius-lg)', padding: 20 }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <span style={{ fontSize: 20 }}>{asset.icon}</span>
              <span style={{ fontWeight: 700, fontSize: '0.9rem' }}>{asset.label}</span>
            </div>
            <span style={{ width: 10, height: 10, borderRadius: '50%', background: statusColor[asset.status], display: 'inline-block' }} />
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
            {asset.sizes.map((size) => (
              <span key={size} style={{ padding: '3px 8px', borderRadius: 'var(--radius-sm)', background: 'var(--surface2)', border: '1px solid var(--border)', fontSize: '0.7rem', fontFamily: 'var(--font-mono)', color: 'var(--text-muted)' }}>
                {size}
              </span>
            ))}
          </div>
          <button style={{ marginTop: 14, fontSize: '0.78rem', fontWeight: 600, color: 'var(--accent)', background: 'transparent', border: 'none', cursor: 'pointer', fontFamily: 'var(--font-sans)', padding: 0 }}>
            Upload files →
          </button>
        </div>
      ))}
    </div>
  </>
);

export default AssetsPage;
